
import Layout from "@/components/layout/Layout";

const PrivacyPolicy = () => (
  <Layout>
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
      <p className="mb-4">
        Your privacy is important to us. This privacy policy explains what personal data we collect, how we use it, and your rights regarding your information.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">Information We Collect</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Account information (email address, name, etc.)</li>
        <li>Usage data (pages visited, interactions, etc.)</li>
        <li>Cookies and tracking technologies</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">How We Use Your Information</h2>
      <ul className="list-disc list-inside mb-4">
        <li>To provide and improve our services</li>
        <li>To communicate with you</li>
        <li>To ensure security and prevent fraud</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">Your Choices</h2>
      <p>
        You may update or delete your information at any time by accessing your account settings. For any questions or requests, contact us at <a href="mailto:support@ai-nexus.com" className="text-ai-indigo underline">support@ai-nexus.com</a>.
      </p>
      <p className="mt-8 text-gray-500 text-sm">
        Last updated: April 22, 2025
      </p>
    </div>
  </Layout>
);

export default PrivacyPolicy;
